// Компонента принимает тип const enum STATUS пример использования => <StatusType roles={[STATUS.TO_REWORK]}>
import React, { PropsWithChildren } from "react";
import { ApplicationStatusGuardProps } from "../../../interfaces/props/ApplicationStatusGuardProps";
import { useAppSelector } from "../../../store/reduxHooks";
import { SELECT_APPLICATION_STATUS } from "../../../store/selectors/requestAppSelector";
import { STATUS_APPLICATION } from "../../../types/indexTypeEnum";

/** Guard по статусам основных заявок. */
export const ApplicationStatusGuard = ({
  children,
  allowedStatuses,
}: PropsWithChildren<ApplicationStatusGuardProps>) => {
  const STATUS_TYPE = useAppSelector(
    SELECT_APPLICATION_STATUS
  ) as STATUS_APPLICATION;
  if (!STATUS_TYPE) {
    return null;
  }

  if (allowedStatuses?.includes(STATUS_TYPE)) {
    return <>{children}</>;
  }

  return null;
};
